import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { EnrollmentResponse } from '../types';
import { apiRequest } from './utils/apiClient';

export const enrollmentsApi = {
  enrollUserToCourse: async (
    courseID: string,
    callback: (data: unknown) => void,
    enrollmentAction: string = 'enroll',
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/change_enrollment`;

    const form = new FormData();
    form.append('course_id', courseID);
    form.append('enrollment_action', enrollmentAction);

    try {
      const data = await apiRequest<unknown>({
        url,
        isAuth: true,
        method: 'POST',
        data: form,
      });
      callback(data);
    } catch (error) {
      logError('Enroll failed', error);
    }
  },

  getUserEnrollmentStatus: async (
    courseID: string,
    successCB?: (data: boolean) => void,
  ): Promise<boolean> => {
    const url = `${getConfig().LMS_BASE_URL}/api/enrollment/v1/enrollment/${courseID}`;

    try {
      const data = await apiRequest<EnrollmentResponse>({
        url,
        isAuth: true,
        method: 'GET',
      });
      successCB?.(data.is_active);
      return data.is_active;
    } catch (error) {
      logError('Fetch enrollment status failed', error);
      return false;
    }
  },
};
